export var ActionsApi;
(function (ActionsApi) {
    ActionsApi["created"] = "created";
    ActionsApi["sent"] = "sent";
    ActionsApi["updated"] = "updated";
    ActionsApi["declined"] = "declined";
})(ActionsApi || (ActionsApi = {}));
export var PurchaseOrderStatusApi;
(function (PurchaseOrderStatusApi) {
    PurchaseOrderStatusApi["SENT"] = "sent";
    PurchaseOrderStatusApi["DECLINED"] = "declined";
    PurchaseOrderStatusApi["PURCHASED"] = "purchased";
    PurchaseOrderStatusApi["CHECKOUT"] = "checkout";
})(PurchaseOrderStatusApi || (PurchaseOrderStatusApi = {}));
//# sourceMappingURL=purchase-order.api.js.map